/**
 * @Author: Calvin Green <calvin>
 * @Date:   2022-01-11T13:51:01+02:00
 * @Email:  calvin@diversitude.com
 * @Last modified by:   calvin
 * @Last modified time: 2022-02-03T14:16:52+02:00
 * @Copyright: Diversitude 2022
 */


export const state = {
    sops: null,
    notifications: null,
    sop_groups:null,
    sop_data: null,
    selected_sop_group: null,
    context_menu_id: -1,
    action_id: null,
}

export const mutations = {
    setNotifications(state, payload){
        state.notifications = payload;
    },
    setSops(state, payload){
        if(payload == null){
            return;
        }
        payload.forEach( doc_group => {
            let found_index = state.sop_groups.findIndex( group => {
                return doc_group.id == group.id;
            })
            if(found_index != -1){
                state.sop_groups[found_index]['sops'] = doc_group.sop_types;
            }
        });
    },
    setSelectedSopGroup(state, payload){
        state.selected_sop_group = payload;
    },
    setSopGroups(state, payload){
        state.sop_groups = payload;
    },
    clearStore(state, payload){
        state.sop_data = payload;
    },
    setSopData(state, payload){
        state.sop_data = payload;
    },
    setRightClickMenuID(state, payload){
        state.context_menu_id = payload;
    },
    setActionID(state, payload){
        state.action_id = payload;
    },
    resetStore(state, payload){
        state.sops = payload;
        state.notifications = payload;
        state.sop_groups = payload;
        state.sop_data = payload;
        state.selected_sop_group = payload;
        state.context_menu_id = -1;
        state.action_id = null;
    }
}

export const actions = {
    /*loadNotifications({commit}){
        return new Promise((resolve, reject)=>{
            window.axios.get('api/clientadmin/notifications/')
            .then((response)=>{
                commit('setNotifications', response.data);
                resolve();
            })
            .catch((e)=>{
                console.log(e)
                reject();
            })
        });
    },*/
    loadSopData({commit}, id){
        return new Promise((resolve, reject)=>{
            window.axios.get('api/clientdocadmin/soptype/' + id)
            .then((response)=>{
                commit('setSopData', response.data);
                resolve();
            })
            .catch((e)=>{
                console.log(e)
                reject();
            })
        });
    },
    loadSops({commit}, id){
        return new Promise((resolve, reject)=>{
            commit('setSops', null);
            window.axios.get('api/clientdocadmin/sopgroup/' + id)
            .then((response)=>{
                commit('setSops', response.data);
                resolve();
            })
            .catch((e)=>{
                console.log(e)
                reject();
            })
        });
    },
    loadSopGroups({commit}, reset = false){
        return new Promise((resolve, reject)=>{
            if(reset == true){
                commit('setSopGroups', null);
                resolve();
            }

            window.axios.get('api/clientdocadmin/sopgroups/')
            .then((response)=>{
                let data_object = response.data;
                let keys = Object.keys(data_object);
                let processed_data = [];
                keys.forEach( key => {
                    let item = data_object[key];
                    item['sops'] = [];
                    processed_data.push(item);
                })
                /*let processed_data = response.data.map( group => {
                    return {...group, sops:[]}
                })*/
                commit('setSopGroups', processed_data);
                resolve();
            })
            .catch((e)=>{
                console.log(e)
                reject();
            })
        });
    },
    selectSopGroup({commit}, sop_group){
        return new Promise((resolve)=>{
            commit('setSelectedSopGroup', sop_group);
            resolve();
        });
    },
    clearSopStore({commit}){
        return new Promise((resolve) => {
            commit('clearStore', null);
            resolve();
        })
    },
    /*eslint-disable-next-line */
    previewSop({commit}, params){//{revision_id : 1}
        return new Promise((resolve, reject) => {
            window.axios.post('api/clientdocadmin/previewsop', params)
            .then( (response) =>{
                resolve(response.data);
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    /*eslint-disable-next-line */
    getSopLink({commit}, params){//{revision_id : 1}
        return new Promise((resolve, reject) => {
            window.axios.post('api/clientdocadmin/previewsop', params)
            .then( (response) =>{
                resolve(response.data);
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    
    loadNotifications({commit}){
        return new Promise((resolve, reject)=>{
            window.axios.get('api/clientuser/notifications')
            .then((response)=>{
                commit('setNotifications', response.data);
                resolve();
            })
            .catch((e)=>{
                console.log(e)
                reject();
            })
        });
    },
    /*eslint-disable-next-line */
    getPreviewB64({commit}, revision_id){//{revision_id : 1}
        return new Promise((resolve, reject) => {
            window.axios.get('api/clientdocadmin/b64preview/' + revision_id)
            .then( (response) =>{
                resolve(response.data);
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    /*eslint-disable-next-line */
    uploadSignedSop({commit}, params){
        return new Promise((resolve, reject) => {
            window.axios.post('api/clientdocadmin/uploadSignedSop', params)
            .then( (response) =>{
                resolve(response.data);
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    /*eslint-disable-next-line */
    setDocumentFlag({}, params){
        return new Promise((resolve, reject) => {
            window.axios.post('api/clientuser/saveactiontracking', params)
            .then( (response) =>{
                resolve(response.data);
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    //* id of the document item that was right clicked
    setContextMenuID({commit}, id){
        return new Promise((resolve)=>{
            commit('setRightClickMenuID', id);
            resolve();
        });
    },

    setActionItemID({commit}, id){
        return new Promise((resolve)=>{
            commit('setActionID', id);
            resolve();
        });
    },

    clearAll({commit}){
        return new Promise((resolve) => {
            commit('resetStore', null);
            resolve();
        })
    },

}
